<!--
 * @Description: 库存管理
 * @Autor: txp
 * @Date: 2021-05-07 16:50:28
-->
<template>
  <div class="announcementview">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 D1D1D1">经销商库存查看</span>
      </div>
      <div class="select_box flex">
        <div class="select_box_input">
          <el-input
            size="small"
            placeholder="产品编码"
            v-model="productCode"
            clearable
          ></el-input>
          <el-input
            size="small"
            placeholder="产品名称"
            v-model="productName"
            clearable
          ></el-input>
        </div>
        <div class="select_box_btn">
          <el-button size="small" type="primary" icon="el-icon-search" @click="queryClick">
            查询
          </el-button>
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
          >
            重置
          </el-button>
        </div>
      </div>
      <div class="text item announcementview_content">
        <!-- <el-button size="small" type="primary" @click="confirmReceipt" class="marginbottom10">
          发货单收货
        </el-button> -->
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          height="450px"
          :header-cell-style="{
            textAlign: 'center',
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5'
          }"
          :cell-style="{
            textAlign: 'center',
            fontSize: '14px',
            color: '#1D1D1D'
          }"
          style="width: 100%"
          :data="table_data"
        >
          <!-- <el-table-column label="全选" type="selection"></el-table-column> -->
          <!-- <el-table-column width="200" prop="deliveryCode" label="发货单编号" fixed="left"> -->
            <!-- <template slot-scope="scope">
              <p class="cursorP" :style="'color:' + theme" @click="handleClickOrder(scope.row.id)">
                {{ scope.row.orderCode }}
              </p>
            </template> -->
          <!-- </el-table-column> -->
          <el-table-column
            v-for="(item, index) in table_data_head"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pageschange">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          prev-text="上一页"
          next-text="下一页"
          @current-change="controllerList()"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request';
import { Storage } from '@/utils/storage';
export default {
  name: 'announcementview',
  data() {
    return {
      productCode: '', //产品编码
      productName: '', //产品名称
      table_data_head: [
        { label: '经销商编码', prop: 'dealerCode' },
        { label: '经销商名称', prop: 'dealerName'},
        { label: '产品编码', prop: 'productCode' },
        { label: '产品名称', prop: 'productName' },
        { label: '库存数量', prop: 'realTimeStock' },
        { label: '单位', prop: 'unitName' },
      ],
      table_data: [], // 1.list分页展示接口接受参数
      loading: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
    }
  },
  watch: {
    screenHeight() {
      this.$nextTick(()=> {
      this.setPageHeight()
    })
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme'
    })
  },
  created() {
    this.controllerList()
  },
  methods: {
    // 获取终端要货列表
    controllerList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        productCode: this.productCode,
        productName: this.productName,
        dealerCode: Storage.l.get('customerCode')
      }
      this.loading = true
     request.post('/dms/dmsDealerStockController/list',params).then(async (res) => {
        this.total = res.result.count
        let companyData = res.result.data.map((item) => {
          let obj = { ...item }
          obj.unitName = '箱'
          return obj
        })
        this.table_data = companyData
        this.loading = false
      })
    },
    //  查询
    queryClick() {
      this.controllerList()
    },
    // 重置
    resetClick() {
      ;(this.pageNum = 1),
        (this.pageSize = 10),
        (this.productCode = ''),
        (this.productName = ''),
      this.controllerList()
    },
  }
}
</script>
<style lang="scss">
.marginbottom10 {
  margin-bottom: 10px;
}
.announcementview {
  width: 1020px;
  height: 100%;
  .el-card {
    height: 100%;
    .el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    .el-table .success-row {
      background: #fafafa;
    }
    .select_box {
      margin-bottom: 20px;
      .select_box_input {
        flex: 1;
        .el-input {
          width: 200px;
          margin-right: 20px;
        }
        .el-input__inner {
          border-radius: 2px;
          background: #f5f5f5;
        }
        .el-range-input {
          background: #f5f5f5;
        }
        .el-range-editor--small.el-input__inner {
          width: 236px !important;
          margin-right: 20px;
        }
      }
      .select_box_btn {
        width: 240px;
        text-align: right;
      }
    }
    .el-table__fixed-right::before {
      height: 0;
    }
    // 分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
    .el-table__body-wrapper::-webkit-scrollbar {
      height: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      background-color: #fafafa;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: $color-primary;
    }
  }
}
</style>
